import { Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheet, type UseModalState } from "@src/appV2/redesign/system/ui-components";

interface ChatOptionsBottomSheetProps {
  modalState: UseModalState;
  onLeaveChat: () => void;
}

export function ChatOptionsBottomSheet(props: ChatOptionsBottomSheetProps) {
  const { modalState, onLeaveChat } = props;

  return (
    <BottomSheet
      footer={<DialogFooter orientation="vertical" />}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      modalState={modalState}
    >
      <Stack
        sx={{
          paddingTop: 4,
          paddingX: 4,
        }}
      >
        <Stack spacing={4}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            sx={{
              color: (theme) => theme.palette.error.light,
              borderColor: (theme) => theme.palette.border?.primary,
            }}
            onClick={() => {
              modalState.closeModal();
              onLeaveChat();
            }}
          >
            Leave chat
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  );
}
